// extracted by mini-css-extract-plugin
export default {"wrapper":"iP-z","ratingContainer":"jP-z","ratingValue":"kP-z","starSprite":"lP-z","ratingLabel":"mP-z","error":"nP-z","errorBox":"oP-z"};